import emailjs from "@emailjs/browser";

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

/**
 * Send the contact form via EmailJS (Zoho Mail SMTP).
 * Template variables used: {{name}}, {{email}}, {{phone}},
 * {{company}}, {{budget}}, {{project_details}}
 */
export const submitContact = async (payload) => {
  const result = await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      name:            payload.name,
      email:           payload.email,
      phone:           payload.phone    || "N/A",
      company:         payload.company  || "N/A",
      budget:          payload.budget   || "N/A",
      project_details: payload.project_details,
    },
    { publicKey: PUBLIC_KEY }
  );
  return result;
};
